<template>
    <v-container class="main-container">
        <div class="text-h4" style="margin-top: 15px; margin-bottom: 25px;">
            利用プラン変更</v-btn>
        </div>

        <!-- 項目 -->
        <v-row v-for="(plan, index) in planList" :key="index">
            <v-card  class="mx-auto planArea" width="1300" min-width="1000">
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="3" xl="3" class="center planName">{{ plan.name }}</v-col>
                            <v-col cols="4" xl="4" class="explanation">{{ plan.explanation }}</v-col>
                            <v-col cols="3" xl="3" class="center feeText">{{ plan.feeText }}</v-col>
                            <v-col cols="2" xl="2" class="center">
                                <div v-if="nowPlanId === plan.id" class="notchange">現在利用中</div>
                                <div v-else-if="plan.id === 3" class="notchange">
                                    <a href="/documents/contact" target="_blank">お問い合わせ</a>
                                </div>
                                <div v-else-if="plan.id === 1 && nowPlanId !== 1" class="notchange">変更不可</div>
                                <div v-else-if="plan.id === 2 && nowPlanId > 2" class="notchange">変更不可</div>
                                <div v-else-if="hasChanged === true" class="notchange">当月変更不可</div>
                                <div v-else>
                                    <button-component color="red" @click="planchange(plan.id)">お申込み</button-component>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-row>
            
    </v-container>
</template>

<script>
    const jsonpAdapter = require('axios-jsonp');
    export default {
        data() {
            return {
                // 表示情報
                planList: [],
                nowPlanId: null,
                hasChanged: false,
            };
        },
        // 初期表示のデータ
        mounted() {
            axios.get('/documents/plan-list').then(res => {
                this.planList = res.data.planList;
                this.nowPlanId = res.data.nowPlanId;
                this.hasChanged = res.data.hasChanged;
            });
        },
        methods: {
            planchange(id) {
                // プランIDをパラメータにして申込画面に遷移
                window.location = "/documents/plan-change?newPlanId=" + id;
            },
        }
    };
</script>

<style scoped lang="scss">
.planArea {
    margin:20px;
}
.planArea:hover {
    background-color:rgba(50,200,50,0.1);
    transition: all  0.5s;
}
.center {
    display: flex;
    align-items: center;
    justify-content: center;
}
.planName {
    font-size: 25px;
    color: #59F;
    font-weight: bold;
}
.explanation {
    color: black;
    white-space: pre-wrap;
    word-wrap: break-word;
}
.feeText {
    font-size: 23px;
    color: black;
    text-decoration: underline;
}
.notchange {
    font-size: 23px;
    color: #aaa;
    text-decoration: underline;
}
</style>
